module.exports = __webpack_public_path__ + "static/rick-004-500028a8fc99833931081808c0a981e8.jpg";